/* CustomTabs lives in custom-tabs.js (always loaded for shared mobile nav). */

document.addEventListener('DOMContentLoaded', function() {

    function emptyCartShopNowLink() {
        return document.querySelector('#rebuy-cart .rebuy-cart__flyout-empty-cart a')
            || document.querySelector('#rebuy-cart a[href="/collections/all"]');
    }

    function pointEmptyCartShopNowHome(shopNow) {
        if (shopNow) shopNow.setAttribute('href', '/');
        return shopNow;
    }

    document.addEventListener('rebuy:smartcart.ready', () => {
        setTimeout(() => {
            hideFromAT(document.querySelector('#rebuy-cart-close'));
            hideFromAT(document.querySelector('#rebuy-cart .flickity-enabled'));
            const shopNow = pointEmptyCartShopNowHome(emptyCartShopNowLink());
            // Delay can fire after smartcart.show — do not re-hide an open empty-cart CTA.
            if (!document.body.classList.contains('rebuy-cart-visible')) {
                hideFromAT(shopNow);
            }
        }, 1000);
    });

    document.addEventListener('rebuy:smartcart.show', (event) => {
        remove(document.querySelector('#rebuy-cart-close'));
        remove(document.querySelector('#rebuy-cart .flickity-enabled'));
        const shopNow = pointEmptyCartShopNowHome(emptyCartShopNowLink());
        remove(shopNow);
    });

    document.addEventListener('rebuy:smartcart.hide', (event) => {
        hideFromAT(document.querySelector('#rebuy-cart-close'));
        hideFromAT(document.querySelector('#rebuy-cart .flickity-enabled'));
        hideFromAT(emptyCartShopNowLink());
    });
      
    function hideFromAT(el) {
        if (!el) return;
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('tabindex', '-1');
    }

    function remove(el) {
        if (!el) return;
        el.removeAttribute('aria-hidden');
        el.removeAttribute('tabindex');
    }
    
    document.querySelectorAll('.product__selectors .radio__label').forEach(item => {
        item.addEventListener('keydown', (e) => {
            if(e.code == 'Space' || e.key == 'Enter' || e.key == 'Escape'){
                e.preventDefault();
                item.closest('.radio__button').querySelector('.radio__input').click();
            }
        });
    })

    // Swiper's a11y module labels each slide "Product X of Y". For custom product cards, put that
    // label on the card's role="group" wrapper instead of the <li>.
    function moveSlideLabelsToCardGroup(swiper) {
        Array.prototype.forEach.call(swiper.slides, function (slide) {
            var card = slide.querySelector('.product-wrapper__card');
            var label = slide.getAttribute('aria-label');
            if (!card || !label) return;
            card.setAttribute('aria-label', label);
            slide.removeAttribute('aria-label');
        });
    }

    if(window.screen.width < 767){
        var galleryProduct = new Swiper(`.product-gallery`, {
            loop: false,
            spaceBetween: 10,
            slidesPerView: 1.15,
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous product',
                nextSlideMessage: 'Next product',
                paginationBulletMessage: 'Go to product {{index}}',
                slideLabelMessage: 'Product {{index}} of {{slidesLength}}',
                // Allyant HUB #695: slides are <li>s, so keep them list items; the label moves to the card group below.
                slideRole: 'listitem',
            },
            pagination: {
            el: '.product-gallery .swiper-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                return '<span class="' + className + '" role="button" tabindex="0" aria-label="Go to product ' + (index + 1) + '"></span>';
                }
            },
        });
        // Swiper initialises (and labels slides) inside the constructor; one instance or an array.
        [].concat(galleryProduct).forEach(moveSlideLabelsToCardGroup);
        function handleFocus(e, i) {
            galleryProduct.slideTo(i);
        }
        const iconSliders = document.querySelectorAll('.product-gallery .swiper-slide');
        iconSliders.forEach((slide, i) => slide.addEventListener('focusin', (e) => handleFocus(e, i)));
    }

    document.querySelectorAll('a[role="button"]').forEach(item => {
        item?.addEventListener('keydown', (e) =>{
            if(e.code == 'Space'){
                e.preventDefault();
                e.stopPropagation();
                item.click();
            }
        })
    })

    function ensureProductZoomBackground(media) {
        if (!media || !media.dataset.zoomBg || media.dataset.zoomBgLoaded) return;
        media.style.backgroundImage = 'url(' + media.dataset.zoomBg + ')';
        media.dataset.zoomBgLoaded = 'true';
    }

    function getActiveProductZoomMedia() {
        return document.querySelector('.gallery-top .swiper-slide-active .product-media__image');
    }

    function bindProductZoomMove(media) {
        if (!media || media.dataset.zoomMoveBound === 'true') return;
        media.dataset.zoomMoveBound = 'true';
        media.addEventListener('mousemove', zoom);
    }

    function setProductZoomState(media, shouldZoom) {
        if (!media || !media.classList.contains('zoom')) return;
        if (shouldZoom) {
            ensureProductZoomBackground(media);
            media.classList.add('active');
            bindProductZoomMove(media);
        } else {
            media.classList.remove('active');
        }
    }

    // Delegate inside the PDP gallery only so later/cloned slides zoom.
    // Do not bind on [data-product-single-media-group] globally — collection product lists reuse that attribute.
    document.querySelectorAll('.product-single__gallery').forEach(function(group) {
        group.addEventListener('click', function(e) {
            if (e.target.closest('a[href], .zoom-in-button, .zoom-out-button, .pan-controls, [data-image-zoom-controls], .flickity-button, .swiper-button, .product-single__thumbnail-link, [data-thumbnail-id], [data-deferred-media-button], .popup-quick-view__gallery-nav-button')) return;
            const media = e.target.closest('.product-media__image.zoom');
            if (!media || !group.contains(media)) return;
            if (media.closest('.is-moving')) return;
            setProductZoomState(media, !media.classList.contains('active'));
        });
    });

    let cards = document.querySelectorAll('.custom-product__card');
    cards.forEach(card => {
        card.addEventListener('focusin', function(e) {
            card.classList.add('is-focused');
        });

        card.addEventListener('focusout', function(e) {
            card.classList.remove('is-focused');
        });
        
        document.addEventListener('click', function(e) {
            if(!card.contains(e.target)) {
                card.classList.remove('is-expanded');
                card.classList.remove('is-focused');
            }
        });

        card.querySelector('.product-grid-item__quick-buy')?.addEventListener('keydown', function(e) {
            if(e.key == 'Enter' || e.key == ' ') {
                e.preventDefault();
                e.stopPropagation();
                this.querySelector('.btn--quick').click();
            }
            if(e.key == 'Escape'){
                e.preventDefault();
                e.stopPropagation();
            }
        });

    })

    let sortInputs = document.querySelectorAll('.collection__sort__input');
    let status = document.getElementById('sort-status');

    sortInputs.forEach((input) => {
    input.addEventListener('change', () => {
        const label = document.querySelector(`label[for="${input.id}"]`);
        status.textContent = `Sorted by ${label.textContent}`;
    });
    });


    let x = 50;
    let y = 50;

    function zoomInActiveMedia() {
        const activeMedia = getActiveProductZoomMedia();
        if (!activeMedia) return;
        setProductZoomState(activeMedia, true);
        x = 50;
        y = 50;
        imageMove(activeMedia, x, y);
    }

    function zoomOutActiveMedia() {
        const activeMedia = getActiveProductZoomMedia();
        if (!activeMedia) return;
        setProductZoomState(activeMedia, false);
        x = 50;
        y = 50;
        imageMove(activeMedia, x, y);
    }

    document.querySelectorAll('.gallery-top .zoom-in-button').forEach((button) => {
        button.addEventListener('keydown', (e) => {
            if (e.code == 'Space' || e.key == 'Enter') {
                zoomInActiveMedia();
            }
        });
        button.addEventListener('click', (e) => {
            e.preventDefault();
            zoomInActiveMedia();
        });
    });

    document.querySelectorAll('.gallery-top .zoom-out-button').forEach((button) => {
        button.addEventListener('keydown', (e) => {
            if (e.code == 'Space' || e.key == 'Enter') {
                zoomOutActiveMedia();
            }
        });
        button.addEventListener('click', (e) => {
            e.preventDefault();
            zoomOutActiveMedia();
        });
    });

    document.querySelectorAll('.gallery-top .pan-controls button')?.forEach(button => {
        button.addEventListener('keydown', (e) => {
            if(e.code == 'Space' || e.key == 'Enter'){
                let position = button.dataset.position;
                let media = getActiveProductZoomMedia();
                if (!media) return;
                switch(position) {
                    case 'scroll-up':
                        e.preventDefault();
                        y = y-3;
                        imageMove(media, x, y);
                        break;

                    case 'scroll-down':
                        e.preventDefault();
                        y = y+3;
                        imageMove(media, x, y);
                        break;
                    case 'scroll-right':
                        e.preventDefault();
                        x = x+3;
                        imageMove(media, x, y);
                        break;

                    case 'scroll-left':
                        e.preventDefault();
                        x = x-3;
                        imageMove(media, x, y);
                        break;
                }
            }
        })

        button.addEventListener('click', (e) => {
            e.preventDefault();
            let position = button.dataset.position;
            let media = getActiveProductZoomMedia();
            if (media) {
                switch(position) {
                    case 'scroll-up':
                        y = y-3;
                        imageMove(media, x, y);
                        break;

                    case 'scroll-down':
                        y = y+3;
                        imageMove(media, x, y);
                        break;
                    case 'scroll-right':
                        x = x+3;
                        imageMove(media, x, y);
                        break;

                    case 'scroll-left':
                        x = x-3;
                        imageMove(media, x, y);
                        break;
                }
            }
        })
    })

    document.querySelector('.gallery-top')?.addEventListener('focusin', function(){
        this.querySelector('.keyboard-controls').classList.remove('sr-only');
        this.classList.add('focused');
    })

    document.querySelector('.gallery-top')?.addEventListener('focusout', function(){
        this.querySelector('.keyboard-controls').classList.add('sr-only');
        this.classList.remove('focused');
    })

    document.querySelector('.gallery-top')?.addEventListener('keydown', (e) => {
        let media = getActiveProductZoomMedia();
        if (!media) return;
        switch(e.key) {
            case 'ArrowUp':
                e.preventDefault();
                y = y-3;
                imageMove(media, x, y);
                break;

            case 'ArrowDown':
                e.preventDefault();
                y = y+3;
                imageMove(media, x, y);
                break;
            case 'ArrowRight':
                e.preventDefault();
                x = x+3;
                imageMove(media, x, y);
                break;

            case 'ArrowLeft':
                e.preventDefault();
                x = x-3;
                imageMove(media, x, y);
                break;
                
            case '+':
                e.preventDefault();
                setProductZoomState(media, true);
                x = 50;
                y = 50;
                imageMove(media, x, y);
                break;

            case '-':
                e.preventDefault();
                setProductZoomState(media, false);
                x = 50;
                y = 50;
                imageMove(media, x, y);
                break;
        }
    })

    function imageMove(media, x, y){
        if (!media) return;
        media.style.backgroundPosition = x + '% ' + y + '%';
    }

    function zoom(e){
        var zoomer = e.currentTarget;
        if (!zoomer) return;
        var rect = zoomer.getBoundingClientRect();
        var pointer = e.touches && e.touches[0] ? e.touches[0] : e;
        var offsetX = (typeof pointer.clientX === 'number') ? (pointer.clientX - rect.left) : 0;
        var offsetY = (typeof pointer.clientY === 'number') ? (pointer.clientY - rect.top) : 0;
        x = zoomer.offsetWidth ? offsetX / zoomer.offsetWidth * 100 : 50;
        y = zoomer.offsetHeight ? offsetY / zoomer.offsetHeight * 100 : 50;
        zoomer.style.backgroundPosition = x + '% ' + y + '%';
    }

    document.querySelectorAll('.accordion__list')?.forEach(accordion => {
        accordion.querySelectorAll('.accordion__item')?.forEach(item=> {
            item.removeAttribute('role');
        })
    })

    const intervalId = setInterval(() => {
        const scrollArea = document.querySelector('[data-rebuy-cart-scroll-area]');
        if (scrollArea) {
            scrollArea.setAttribute('data-scroll-lock-scrollable', 'true');
            clearInterval(intervalId);
        }
    }, 1000);
    
    document.querySelectorAll('.customer-reviews').forEach(element => {
        element.addEventListener('mouseover', function(){
            redirect(element)
        })
    })

    function redirect(element){
        let redirectLink = element.dataset.link;
        if(document.querySelectorAll('.bv_button_buttonFull')){
            document.querySelectorAll('.bv_button_buttonFull').forEach(button => {
                button.addEventListener('click', function(e){
                    e.preventDefault();
                    window.location.href = redirectLink;
                })
            })
        }
    }

    let dialog = document.querySelector('#search-results-desktop');
    let mobielDialog = document.querySelector('#search-results-mobile');
    let firstFocusableElement = document.querySelector('#search-input-desktop');
    let mobileFirstFocusableElement = document.querySelector('#search-input-mobile');

    if (window.innerWidth < 767) {
        mobielDialog.addEventListener('keydown', function(e) {
            let mobileLastFocusableElement = document.querySelector('#search-results-mobile #predictiveSearchActionViewAllResults');
            if(e.target == mobileFirstFocusableElement && e.key == 'Tab' && e.shiftKey) {
                e.preventDefault();
                mobileLastFocusableElement.focus();
            } else if(e.target == mobileLastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
                e.preventDefault();
                mobileFirstFocusableElement.focus();
            }
        });

        mobileFirstFocusableElement.addEventListener('keydown', function(e) {
            let mobileLastFocusableElement = document.querySelector('#search-results-mobile #predictiveSearchActionViewAllResults');
            if(e.target == mobileFirstFocusableElement && e.key == 'Tab' && e.shiftKey) {
                e.preventDefault();
                mobileLastFocusableElement.focus();
            }
        });
    } else {
        dialog.addEventListener('keydown', function(e) {
            let lastFocusableElement = document.querySelector('#search-results-desktop #predictiveSearchActionViewAllResults');
            if(e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
                e.preventDefault();
                lastFocusableElement.focus();
            } else if(e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
                e.preventDefault();
                firstFocusableElement.focus();
            }
        });

        firstFocusableElement.addEventListener('keydown', function(e) {
            let lastFocusableElement = document.querySelector('#search-results-desktop #predictiveSearchActionViewAllResults');
            if(e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
                e.preventDefault();
                lastFocusableElement.focus();
            }
        });
    }

    function waitForElement(selector, callback) {
        const checkExist = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
            clearInterval(checkExist);
            callback(element);
            }
        }, 100); // checks every 100ms
    }

    waitForElement('.pw-cashback-header-row-right', (el) => {
        let element = document.querySelector('.pw-cashback-header-row-right');
        if (element) {
            element.setAttribute('role', 'button');
            element.setAttribute('tabindex', '0');
            element.setAttribute('aria-expanded', 'false');

            // Allow keyboard users to activate it
            element.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    element.click();
                }
            });

            element.addEventListener('click', function(){
                let expanded = element.getAttribute('aria-expanded') === 'true';
                element.setAttribute('aria-expanded', !expanded);
            })

            const el = document.querySelectorAll('.pw-cashback-benefits-title');
            if (el) {
                el.forEach(element => {
                    element.outerHTML = `<h2 class="${element.className}" role="${element.getAttribute('role')}" style="${element.getAttribute('style')}">${element.textContent}</h2>`;
                })
            }
        }
    });
    
    const elementsToWatch = [
        {
            selector: "#callout-bubble-container",
            title: "Callout bubble container",
        },
        {
            selector: "#voiceflow-chat",
            title: "Voiceflow Chat Widget Container",
        },
        {
            selector: "#PBarNextFrame",
            title: "PBarNextFrame Container",
        }
    ];

    const pending = new Map(
        elementsToWatch.map((item) => [item.selector, item])
    );

    let observer;

    function trySetTitles() {
        pending.forEach((item, selector) => {
            const el = document.querySelector(selector);
            if (el) {
            el.setAttribute("title", item.title);
            pending.delete(selector);
            }
    });

    if (!pending.size && observer) observer.disconnect();
    }

    // Run once first
    trySetTitles();

    // Only observe if something is still pending
    if (pending.size) {
        observer = new MutationObserver(trySetTitles);
        observer.observe(document.body, { childList: true, subtree: true });
    }

    /* -------------------------------
     UPDATE THESE SELECTORS ONLY
    --------------------------------*/
    const POPUP_SELECTOR  = '#rebuy-widget-249294 .rebuy-widget-container';             // main popup container
    const CLOSE_SELECTOR  = '#rebuy-widget-249294 .rebuy-modal-close';      // close (X)
    const ACCEPT_SELECTOR = '#rebuy-widget-249294 .description';        // CTA button
    /* --------------------------------*/

    // Make sure dataLayer exists
    window.dataLayer = window.dataLayer || [];

    function pushEvent(eventName, params) {
        window.dataLayer.push({
            event: eventName,
            ...params
        });
    }

    // Promotion metadata (you can tweak these names/IDs)
    const promoData = {
        promotion_id:   'REBUY_POPUP',
        promotion_name: 'Rebuy Offer Popup',
        creative_name:  'Rebuy product page modal',
        creative_slot:  'product_page'
    };

    // GA4-style events via dataLayer
    function trackPopupShown() {
        pushEvent('view_promotion', {
            popup_location: window.location.href,
            page_location: window.location.href,
            ecommerce: {
                items: [promoData]
            }
        });
    }

    function trackPopupClosed() {
        pushEvent('promotion_dismiss', {
            popup_location: window.location.href,
            page_location: window.location.href, 
            promotion_id: promoData.promotion_id,
            promotion_name: promoData.promotion_name,
            creative_name: promoData.creative_name,
            creative_slot: promoData.creative_slot
        });
    }

    function trackPopupAccepted() {
        pushEvent('select_promotion', {
            popup_location: window.location.href,
            page_location: window.location.href,
            ecommerce: {
                items: [promoData]
            }
        });
    }

    function setupPopupTracking(popupEl) {
        if (!popupEl) return;

        const closeBtn = popupEl.querySelector(CLOSE_SELECTOR);
        if (closeBtn) {
            closeBtn.addEventListener('click', function () {
                trackPopupClosed();
            }, { once: true });
        }

        const acceptBtn = popupEl.querySelector(ACCEPT_SELECTOR);
        if (acceptBtn) {
            acceptBtn.addEventListener('click', function () {
                trackPopupAccepted();
            }, { once: true });
        }

        const classObserver = new MutationObserver(function () {
            if (!popupEl.classList.contains('is-hidden')) {
                trackPopupShown();
                classObserver.disconnect();
            }
        });

        classObserver.observe(popupEl, {
            attributes: true,
            attributeFilter: ['class']
        });

        if (!popupEl.classList.contains('is-hidden')) {
            trackPopupShown();
            classObserver.disconnect();
        }
    }

    const existingPopup = document.querySelector(POPUP_SELECTOR);
    if (existingPopup) {
        setupPopupTracking(existingPopup);
    }

    const waitForPopup = new MutationObserver(function (mutations) {
        for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
            if (!(node instanceof Element)) continue;

            if (node.matches(POPUP_SELECTOR)) {
            setupPopupTracking(node);
            waitForPopup.disconnect();
            return;
            }

            const found = node.querySelector(POPUP_SELECTOR);
            if (found) {
                setupPopupTracking(found);
                waitForPopup.disconnect();
            return;
            }
        }
        }
    });

    waitForPopup.observe(document.body, {
        childList: true,
        subtree: true
    });


    (function () {
    /**
     * Upgrade Affirm modal trigger <a> to button semantics
     * WCAG 2.1 – Name, Role, Value + Consistent Identification
     */

    function upgradeAffirmTrigger(trigger) {
        if (trigger.dataset.a11yUpgraded === "true") return;

        // Remove misleading link behavior
        trigger.removeAttribute("href");

        // Apply button semantics
        trigger.setAttribute("role", "button");
        trigger.setAttribute("tabindex", "0");

        // Ensure keyboard support (Space + Enter)
        trigger.addEventListener("keydown", (e) => {
        if (e.key === " " || e.key === "Spacebar") {
            e.preventDefault();
            trigger.click();
        }
        });

        trigger.dataset.a11yUpgraded = "true";
    }

    function scanAndUpgrade() {
        document.querySelectorAll(".affirm-modal-trigger").forEach(upgradeAffirmTrigger);
    }

    scanAndUpgrade();

    const observer = new MutationObserver(scanAndUpgrade);

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
    })();

    let collectionHandle = sessionStorage.getItem('lastCollectionHandle');
    let collectionTitle = sessionStorage.getItem('lastCollectionTitle');
    let crumb = document.querySelector('.breadcrumbs__collection-link .breadcrumbs__link');

    if (crumb && collectionHandle && collectionTitle) {
        crumb.textContent = collectionTitle;
        crumb.href = collectionHandle;
    }
})


